module.exports = __webpack_public_path__ + "static/media/broken-piggy-bank.32a6a727.bin";